export default __webpack_public_path__ + "static/media/icon-fitness.96295d04.svg";